"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ACTION_TYPES = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

// todo: maybe create a file especially for all fusion-actions
var ACTION_TYPES = {
  START_VIDEO: 'startVideo',
  STARTEND_VIDEO: 'startEndVideo'
};
exports.ACTION_TYPES = ACTION_TYPES;

var VideoActionManager = /*#__PURE__*/function () {
  function VideoActionManager(videoElement) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, VideoActionManager);
    (0, _defineProperty2["default"])(this, "onPlaying", function () {
      console.log('onplaying callback');
      _this.isPlaying = true;
      /*
      Testing if this is the first time video is being played.
      Otherwise we don't want to go back to startTime if user stops half way through the video for example
       */

      if (_this.isInitialPlay) {
        _this.videoElement.currentTime = _this.startTime;
        _this.isInitialPlay = false;
      }

      if (_this.endTime) {
        _this.videoIntervalHandler = setInterval(_this.onVideoTimeUpdate, 200);
      }
    });
    (0, _defineProperty2["default"])(this, "onPause", function () {
      _this.isPlaying = false;
      clearInterval(_this.videoIntervalHandler);
    });
    (0, _defineProperty2["default"])(this, "onEnded", function () {
      _this.isInitialPlay = true;
    });
    (0, _defineProperty2["default"])(this, "onSeeked", function () {
      // Todo: add more sophisticated behavior

      /*
      User seeked to a Point before startpoint set by action.
      Interpreting this as a will to remove the action from the video element.
       */
      if (_this.videoElement.currentTime < _this.startTime) {
        _this.cleanUp();
      }
      /*
      When a user seeks, pause is being called. The video automatically keeps playing after seeking though.
      This results in the onPlaying callback to not be called, so that isPlaying wont be set to true.
       */


      _this.isPlaying = true;
    });
    (0, _defineProperty2["default"])(this, "onVideoTimeUpdate", function () {
      if (_this.videoElement.currentTime >= _this.endTime) {
        _this.videoElement.pause();

        _this.videoElement.currentTime = _this.startTime;
        clearInterval(_this.videoIntervalHandler);
      }
    });
    this.videoElement = videoElement;
    this.startTime = 0;
    this.endTime = 0;
    this.videoIntervalHandler = null;
    this.isInitialPlay = true;
    this.isPlaying = false;
  }

  (0, _createClass2["default"])(VideoActionManager, [{
    key: "executeAction",
    value: function executeAction(type) {
      /*
      cleaning up in order to execute new action (if multiple in a row on same element)
       */
      this.cleanUp();

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      switch (type) {
        case ACTION_TYPES.START_VIDEO:
          this._startVideo.apply(this, args);

          break;

        case ACTION_TYPES.STARTEND_VIDEO:
          this._startEndVideo.apply(this, args);

          break;
      }
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      this._removeEventListeners();

      this.isInitialPlay = true;
      clearInterval(this.videoIntervalHandler);
    }
  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      this.videoElement.addEventListener('playing', this.onPlaying);
      this.videoElement.addEventListener('pause', this.onPause);
      this.videoElement.addEventListener('seeked', this.onSeeked);
      this.videoElement.addEventListener('ended', this.onEnded);
    }
  }, {
    key: "_removeEventListeners",
    value: function _removeEventListeners() {
      this.videoElement.removeEventListener('playing', this.onPlaying);
      this.videoElement.removeEventListener('pause', this.onPause);
      this.videoElement.removeEventListener('seeked', this.onSeeked);
      this.videoElement.removeEventListener('ended', this.onEnded);
    }
  }, {
    key: "_startVideo",
    value: function _startVideo() {
      if (arguments.length < 1) {
        return;
      }

      this.startTime = arguments.length <= 0 ? undefined : arguments[0];
      console.log('VideoActionManager: startVideo ', this.startTime);
      /*
      onPlaying callback wont be called if video is playing and we received a new action on this video.
      Therefore we are checking if it is playing and setting current time immediately, which works because
      user action has already happened.
      */

      if (this.isPlaying) {
        this.videoElement.currentTime = this.startTime;
        this.isInitialPlay = false;
      }

      this._addEventListeners();
    }
  }, {
    key: "_startEndVideo",
    value: function _startEndVideo() {
      if (arguments.length < 2) {
        return;
      }

      this.startTime = arguments.length <= 0 ? undefined : arguments[0];
      this.endTime = arguments.length <= 1 ? undefined : arguments[1];
      console.log('VideoActionManager: startEndVideo ', this.startTime, this.endTime);
      /*
      onPlaying callback wont be called if video is playing and we received a new action on this video.
      Therefore we are checking if it is playing and setting current time immediately, which works because
      user action has already happened.
      Also we have to check for initialPlay, because we set isPlaying in seeked to true, which is not right if
      we programmatically set current time.
       */

      if (this.isPlaying && this.isInitialPlay) {
        this.videoElement.currentTime = this.startTime;
        this.isInitialPlay = false;
        this.videoIntervalHandler = setInterval(this.onVideoTimeUpdate, 200);
      }

      this._addEventListeners();
    }
  }]);
  return VideoActionManager;
}();

var _default = VideoActionManager;
exports["default"] = _default;